// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"301":"d09d4dd0","488":"0f01ec22","724":"5581b1fe","880":"971072da","932":"8963d114"}[chunkId] + ".chunk.css";
};